import { render, staticRenderFns } from "./CustomPagination.vue?vue&type=template&id=d1f5c58a&scoped=true"
import script from "./CustomPagination.vue?vue&type=script&lang=js"
export * from "./CustomPagination.vue?vue&type=script&lang=js"
import style0 from "./CustomPagination.vue?vue&type=style&index=0&id=d1f5c58a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f5c58a",
  null
  
)

export default component.exports